import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AssetComp from 'components/AssetComp';
import { PieChart } from 'ui-library';
import './PieChartWithLegend.css';
import { useFormatting } from 'locale';
import { PieChartWIthLegendProps } from './PieChartWithLegend.types';

const PieChartWithLegend: FC<PieChartWIthLegendProps> = ({
    chartData,
    className = '',
}) => {
    const { t } = useTranslation();

    const { getAmountWithDecimals } = useFormatting();

    const chartDataTranslated = useMemo(() => [...chartData]?.map(data => ({
        ...data,
        name: t(`allocationChart.legends.${data?.name}`),
    })), [chartData, t]);

    const percentFormat = useCallback((v: number) => `${v.toFixed(1)}%`, []);

    return (
        <div className={`pie-chart-with-legend ${className}`}>
            <div className="pie-chart-with-legend--pieChart-wrapper">
                <PieChart data={chartDataTranslated} percentFormat={percentFormat} disableLegend tooltip showCHFValue />
            </div>
            <div className="pie-chart-with-legend--assets-container">
                <div className="pie-chart-with-legend--column">
                    <div className="pie-chart-with-legend--assets-group">
                        {chartDataTranslated?.map(data => (
                            <AssetComp
                                key={data?.name}
                                colorClass={data?.className || ''}
                                title={data?.name}
                                amount={getAmountWithDecimals(data?.value)}
                                percentage={`${(+data?.percent)?.toFixed(1)}%`}
                                description={data?.description || ''}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PieChartWithLegend;
